import type { ResourceScheduleTimelineMode } from './resourceScheduleWindow';

const RESOURCE_SCHEDULE_NOW_LANDING_OFFSET_RATIO = 0.28;

interface BuildResourceScheduleLandingKeyOptions {
  selectedDateDayKey: string;
  timelineMode: ResourceScheduleTimelineMode;
  isToday: boolean;
}

interface ResolveResourceScheduleInitialScrollTargetOptions {
  timelineMode: ResourceScheduleTimelineMode;
  isToday: boolean;
  currentTimePosition: number | null;
  clientWidth: number;
}

export function buildResourceScheduleLandingKey({
  selectedDateDayKey,
  timelineMode,
  isToday,
}: BuildResourceScheduleLandingKeyOptions): string {
  return `${selectedDateDayKey}:${timelineMode}:${isToday ? 'today' : 'other'}`;
}

export function resolveResourceScheduleInitialScrollTarget({
  timelineMode,
  isToday,
  currentTimePosition,
  clientWidth,
}: ResolveResourceScheduleInitialScrollTargetOptions): {
  shouldLandAroundNow: boolean;
  target: number;
  behavior: 'smooth' | 'auto';
} {
  const shouldLandAroundNow = timelineMode === 'dynamic' && isToday && currentTimePosition != null;

  if (!shouldLandAroundNow) {
    return {
      shouldLandAroundNow: false,
      target: 0,
      behavior: 'auto',
    };
  }

  return {
    shouldLandAroundNow: true,
    target: Math.max(0, currentTimePosition - clientWidth * RESOURCE_SCHEDULE_NOW_LANDING_OFFSET_RATIO),
    behavior: 'smooth',
  };
}